import React from "react";
import {IonToast} from "@ionic/react";

export const AuthenticationErrorToast: React.FC<{error: string | null}> = params => {
    return <IonToast color="danger" isOpen={params.error != null} message={"Authentication error: " + params.error} />
};
